export type ConvertedTime = {
    hours: number,
    minutes: number,
    seconds: number
}

export const convertMillisecondsToTime = (milliseconds: number | undefined = 0): ConvertedTime => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { hours, minutes, seconds };
}

const formatCeilNumber = (num: number) => {
    return num > 0 ? num : 0
}

const defaultFormatter = (convertedTime: ConvertedTime) => {
    return `${formatCeilNumber(convertedTime.hours)}ч ${formatCeilNumber(convertedTime.minutes)}мин`
}

export const hoursAndMinutesTimeFormatter = (convertedTime: ConvertedTime) => {
    if (convertedTime.minutes === 0 && convertedTime.hours === 0) return '0 ч'

    return `${formatCeilNumber(convertedTime.hours)}.${formatCeilNumber(Math.round(convertedTime.minutes / 60))} ч`
}

export const dataLabelsFormatter = (convertedTime: ConvertedTime) => {
    if (convertedTime.minutes === 0 && convertedTime.hours === 0) {
        return ''
    }

    return `${convertedTime.hours ? formatCeilNumber(convertedTime.hours) + 'ч ' : ''}${formatCeilNumber(convertedTime.minutes)}мин`
}

type TimeFormatter = (time: number | ConvertedTime, formatter?: (convertedTime: ConvertedTime) => string) => string

export const formatTime: TimeFormatter = (time, formatter = defaultFormatter) => {
    const timeToFormat = typeof time !== 'number' ? time : convertMillisecondsToTime(time);

    return formatter(timeToFormat);
}